// Mock site data for testing purposes
export const mockSites = [
  {
    id: 1,
    name: 'Corporate Headquarters',
    site_account: 'CORP001',
    domain: 'company.com',
    url: 'https://company.com',
    status: 'active',
    type: 'corporate',
    region: 'North America',
    created_at: '2024-01-15T10:30:00Z',
    updated_at: '2024-03-20T14:45:00Z',
    description: 'Main corporate website and landing page',
    traffic_monthly: 45000,
    performance_score: 92,
    seo_score: 88,
    security_status: 'secure',
    logo: '/uploads/site-logos/corporate-headquarters-logo.png'
  }
];

// Site types for filtering
export const siteTypes = [
  'corporate',
  'ecommerce',
  'content',
  'landing',
  'support',
  'portal',
  'documentation'
];

// Site regions for filtering
export const siteRegions = [
  'North America',
  'Europe',
  'Asia Pacific',
  'Latin America',
  'Africa',
  'Global'
];

// Site statuses for filtering
export const siteStatuses = [
  'active',
  'inactive'
];

// Security statuses
export const securityStatuses = [
  'secure',
  'warning',
  'critical',
  'unknown'
];
